import { useTranslation } from '@/features/i18n';
import { Button } from '@/ui/buttons/Button';

type SubscribeStepProps = {
  children: React.ReactNode;
  heading: string;
  isCurrentStep: boolean;
  applyCouponComponent?: React.ReactNode;
  choiceDescription?: string;
  choiceName?: string;
  discountedPrice?: string;
  setStepAsCurrent?: () => void;
};

export const SubscribeStep = ({
  applyCouponComponent,
  children,
  choiceDescription,
  choiceName,
  discountedPrice,
  heading,
  isCurrentStep,
  setStepAsCurrent,
}: SubscribeStepProps) => {
  const { t } = useTranslation('translation');
  const choiceSelected =
    (choiceName?.length ?? 0) > 0 || (choiceDescription?.length ?? 0) > 0;

  return (
    <div className="flex flex-col gap-8 bg-background-secondary p-8 rounded-lg shadow-md w-full relative">
      <h1 className="text-xl sm:text-3xl pt-4 sm:pt-0 font-bold self-start">
        {heading}
      </h1>
      {!isCurrentStep && choiceSelected && (
        <div className="flex flex-col gap-2">
          <h3 className="text-xl sm:text-2xl text-text-primary">
            {discountedPrice ? (
              <>
                <span>{discountedPrice}</span>
                <span className="line-through text-gray-500 ml-2">
                  {choiceName}
                </span>
              </>
            ) : (
              choiceName
            )}
          </h3>
          <p className="text-xl text-text-secondary">{choiceDescription}</p>
        </div>
      )}
      {isCurrentStep && children}
      {applyCouponComponent && <>{applyCouponComponent}</>}
      {!isCurrentStep && setStepAsCurrent && (
        <Button
          variant="secondary"
          className="absolute right-4 top-2 sm:top-8"
          onClick={setStepAsCurrent}
        >
          {t('subscriptions.change')}
        </Button>
      )}
    </div>
  );
};
